// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170404/js/" + chunkId + "." + {"44":"56d26b6c","225":"3adbca4e","481":"0c425581","486":"6cba7e5d","770":"17dc63a2"}[chunkId] + ".0.5258805258221477.chunk.js";
};